import { useMemo } from 'react';
import { useCheckout } from '~/features/checkout/hooks';
import { selectedCarrierHasDeliveryAddress } from '../../DeliveryAddressMap/utils/selectedCarrierHasDeliveryAddress';
import { useCheckoutState } from '~/features/checkout/hooks/useCheckoutState';

export const useIsValid = () => {
    const {
        deliveryAddress,

        isAlternateShippingValid,
        deliveryDate,
        changingCarrier,
        // isFetching,
        // error,
    } = useCheckout();

    const { deliveryMethod, carrier, billingAddress, vendorSelectedDroppoint } = useCheckoutState();

    return useMemo(() => {
        if (!billingAddress) return false;
        if (!deliveryMethod) return false;
        if (!deliveryAddress) return false;
        if (!carrier) return false;
        if (changingCarrier) return false;
        if (vendorSelectedDroppoint) {
            if (isAlternateShippingValid) {
                return isAlternateShippingValid;
            }

            return false;
        }

        if (deliveryMethod === 'dropPoint') {
            if (
                Object.keys(deliveryAddress).length === 0 ||
                deliveryAddress?.deliveryType === 'store' ||
                deliveryAddress?.deliveryType === 'alternative'
            )
                return false;
            //@ts-ignore
            if (!selectedCarrierHasDeliveryAddress(carrier[deliveryMethod], deliveryAddress)) {
                return false;
            }
        }

        if (deliveryMethod === 'addressDelivery') {
            if (Object.keys(deliveryAddress).length === 0) return false;
            if (!carrier[deliveryMethod]) return false;

            if (isAlternateShippingValid) {
                return isAlternateShippingValid;
            }
        }

        if (deliveryMethod === 'truckDelivery') {
            if (isAlternateShippingValid) {
                return isAlternateShippingValid;
            }

            return true;
        }

        if (deliveryMethod === 'clickAndCollect') {
            if (
                Object.keys(deliveryAddress).length === 0 ||
                deliveryAddress?.deliveryType === 'droppoint' ||
                deliveryAddress?.deliveryType === 'alternative'
            )
                return false;
        }

        if (deliveryMethod === 'virtual') {
            if (!billingAddress) return false;
        }

        return true;
    }, [
        deliveryAddress,
        deliveryMethod,
        carrier,
        billingAddress,
        isAlternateShippingValid,
        deliveryDate,
        changingCarrier,
        vendorSelectedDroppoint,
        // isFetching,
        // error,
    ]);
};
